import { render } from "./ModalManageTags.vue?vue&type=template&id=f329ec1c"
import script from "./ModalManageTags.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalManageTags.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/ModalManageTags.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f329ec1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f329ec1c', __exports__)) {
    api.reload('f329ec1c', __exports__)
  }
  
  module.hot.accept("./ModalManageTags.vue?vue&type=template&id=f329ec1c", () => {
    api.rerender('f329ec1c', render)
  })

}


export default __exports__